import React from "react";
import WidgetSelector from "./WidgetSelector";

export default function WidgetItemUnitSelector({
  value,
  displayValue,
  item_units,
  onChange,
  reloadDropdownData,
  viewOnly,
  size,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={item_units}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Item Unit"
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  );
}
